import React from 'react';
import NoKolla from './NoKolla';
import Kolla from './Kolla';
import { useQuery } from 'react-query';
import { getKollaLeads} from '../../api/services';
import { LinearProgress } from '@mui/material';

const KollaPage: React.FC = () => {
    // Fetch Kolla data
    const { data: KollaData, isLoading: isLoadingKolla, error: KollaError, refetch: refetchKolla } = useQuery('getKolla', getKollaLeads);

    const combinedData = [
        ...(KollaData?.data || []), 
    ];


    if (combinedData.length === 0) {
        return <NoKolla />;
    }

    return <Kolla KollaData={combinedData} onDelete={() => { refetchKolla();  }} />;
};

export default KollaPage;
